import { useState } from 'react';

export const TEST_PIPELINE_TABS = {
  INPUT_EVENT: '0',
  PIPELINE_OUTPUT: '1',
  INTEGRATION_OUTPUT: '2',
  SERVER_RESPONSE: '3',
};

export default function useTestPipelineTabs() {
  const [selectedTab, setSelectedTab] = useState(TEST_PIPELINE_TABS.INPUT_EVENT);

  const onSelectTab = newTab => {
    setSelectedTab(newTab);
  };

  return [selectedTab, { onSelectTab }];
}
